import React, { useEffect, useState } from 'react';

import { callApi } from '../../pages/commonapicall/fetchdata';

import { tokens } from '../../theme/theme';

import { API_ENDPOINTS } from '../../config/api/apiCall';

import CallAlertBar from '../../Layout/Alertbar';
import Header from '../../Layout/Header';
import {
    Table,
    TableBody,
    
    TableCell,
    Grid,
    TableContainer,
    TableHead,
    TableRow,
 
    Box,
    useTheme,
  
  
    Divider,
} from '@mui/material';



const Subscriptionmodel = ({ setIsEditModalOpen, setCompanyList, setIsSubscriptionModelOpen }) => {


    const theme = useTheme();
 
    const colors = tokens(theme.palette.mode);
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

    const [subscriptionlist, setSubscriptionlist] = useState([]);
    const [userRoles, setUserRoles] = useState([]);

    const LoadSubscriptionModelList = () => {

        callApi(API_ENDPOINTS.COMPANY_GetSubscriptionModelListFunc, 'POST', { 'Content-Type': 'application/json' })
            .then(data => {
                // Update state with fetched data

                if (data.length > 0) {
                    setSubscriptionlist(data);

                }
                else {
                    setParentRollSeverityvalue('warning');
                    setParentRollMessageValue('No user data found..!');
                    setParentRollAlertTitleValue('Warning');
                    setParentRollMsgOpen(true);
                }
            })
            .catch(error => {
                // // Update state with error message        
                setParentRollSeverityvalue('error');
                setParentRollMessageValue('Unable to load the user details');
                setParentRollAlertTitleValue('Error');
                setParentRollMsgOpen(true);
            });
    };

    const LoadRoleList = () => {
        let requestBody = {
            CompanyId: 1,
        };

        callApi(API_ENDPOINTS.USER_getUserRoles, 'POST', { 'Content-Type': 'application/json' }, requestBody)
            .then(data => {
                // Update state with fetched data

                if (data.length > 0) {
                    setUserRoles(data);
                }
                else {
                    setParentRollSeverityvalue('warning');
                    setParentRollMessageValue('No user roles data found..!');
                    setParentRollAlertTitleValue('Warning');
                    setParentRollMsgOpen(true);
                }
            })
            .catch(error => {
                // // Update state with error message        
                setParentRollSeverityvalue('error');
                setParentRollMessageValue('Unable to load user role details');
                setParentRollAlertTitleValue('Error');
                setParentRollMsgOpen(true);
            });
    };

    useEffect(() => {
        LoadSubscriptionModelList();
        LoadRoleList();
    }, []);

  




    const handleBackDashboard = () => {
        //navigate("/CompanyManagement");

        setIsEditModalOpen(false);
        setCompanyList(true);
        setIsSubscriptionModelOpen(false);
    }
    return (
        <Grid>





            <Header title={'Subscription Model Details'} subtitle="" callback={handleBackDashboard} />
            <Divider />

            <CallAlertBar
                parentRollMsgOpen={parentRollMsgOpen}
                setParentRollMsgOpen={setParentRollMsgOpen}
                parentRollSeverityvalue={parentRollSeverityvalue}
                setParentRollSeverityvalue={setParentRollSeverityvalue}
                parentRollAlertTitleValue={parentRollAlertTitleValue}
                setParentRollAlertTitleValue={setParentRollAlertTitleValue}
                parentRollMessageValue={parentRollMessageValue}
                setParentRollMessageValue={setParentRollMessageValue}
            />


            <Grid container padding={1} spacing={1}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Box
                        gridColumn="span 9"
                        gridRow="span 2"
                        alignItems="center"
                        justifyContent="center"
                        // padding={1}
                        sx={{
                            "& .MuiTable-root": {
                                border: "none",
                                size: "small",
                            },
                            "& .MuiTableCell-root": {
                                borderBottom: "none",
                                border: "1px solid",
                                borderColor: `${colors.primary[400]} !important`,
                                padding: "2px",  // Further reduced padding
                            },
                            "& .MuiTableHead-root": {
                                borderBottom: "none",
                            },
                            "& .MuiTableBody-root": {
                                overflowY: "auto",
                            },
                            "& .MuiCheckbox-root": {
                                color: `${colors.blueAccent[200]} !important`,
                                size: "small",
                            },
                            "& .MuiTableFooter-root": {
                                borderTop: "none",
                                backgroundColor: colors.blueAccent[700],
                                height: "10px",
                            },
                            "& .MuiButton-text": {
                                color: `${colors.grey[100]} !important`,
                            },
                            // scroll bar
                            maxHeight: {
                                xs: '72vh', // Extra small devices (phones)
                                sm: '72vh', // Small devices (tablets)
                                md: '74vh', // Medium devices (small laptops)
                                lg: '80vh', // Large devices (desktops)
                                xl: '80vh', // Extra large devices (large desktops)
                            },
                            overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                            '&::-webkit-scrollbar': {
                                width: '8px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: colors.primary[400],
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: colors.blueAccent[600],
                                borderRadius: '10px',
                                '&:hover': {
                                    background: colors.blueAccent[800],
                                },
                            },
                            '&::-webkit-scrollbar-corner': {
                                background: colors.primary[700],
                            }
                        }}
                    >
                        <TableContainer>
                            <Table size="small">
                                <TableHead sx={{ height: 30 }}>
                                    <TableRow>

                                        <TableCell>MODEL NAME</TableCell>
                                        <TableCell>TONNAGE/YEAR</TableCell>
                                        <TableCell>PRICE/TON</TableCell>
                                        <TableCell>PRICE/SUBSCRIPTION</TableCell>
                                        <TableCell>TARGET TPD</TableCell>
                                        <TableCell>COMPANY SIZE</TableCell>
                                        <TableCell>MODEL DESCRIPTION</TableCell>
                                        {/* <TableCell>ACTIONS</TableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {subscriptionlist.map((user) => (
                                        <TableRow sx={{ height: 35 }}key={user.model_id}>



                                            <TableCell>{user.model_name}</TableCell>
                                            <TableCell>{user.model_annual_prodn_capacity}</TableCell>
                                            <TableCell>{user.model_price_per_ton}</TableCell>
                                            <TableCell>{user.model_price_per_year}</TableCell>
                                            <TableCell>{user.model_target_tpd}</TableCell>
                                            <TableCell>{user.model_company_type}</TableCell>
                                            <TableCell>{user.model_desc}</TableCell>
                                          
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Grid>

            </Grid>



        </Grid>
    );
};

export default Subscriptionmodel;
